module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0153.jpg?v=d26c93e1";